export enum FileType {
  Video = 'VIDEO',
  Img = 'IMG',
  Doc = 'DOC'
}
